var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({key:_vm.spriteHref,class:['gl-icon', _vm.iconSizeClass, _vm.iconVariantClass],attrs:{"data-testid":`${_vm.name}-icon`,"role":"img","aria-hidden":!_vm.ariaLabel,"aria-label":_vm.ariaLabel}},_vm.$listeners),[_c('use',{attrs:{"href":_vm.spriteHref}})])
}
var staticRenderFns = []

export { render, staticRenderFns }